import React, { ReactNode } from 'react';
import { ExceedConstrain } from '@moda/om';
import { ErrorLike } from '@apollo/client';
import { SortOption } from '../../../constants';
import { StickUnderNav } from '../../StickUnderNav';
import { PLPBreadcrumbs } from '../../PLPBreadcrumbs';
import { SalePercentageTags } from '../../SalePercentageTags/SalePercentageTags';
import { ProductListPageResultFragment, GuidePageQuery } from '../../../generated/types';
import { ProductListingMobileSort } from './ProductListingMobileSort';
import { ProductListingMobileFilter } from './ProductListingMobileFilter';
import { ProductListingMobileHeader } from './ProductListingMobileHeader';

import './ProductListingMobile.scss';

type DisplayPage = NonNullable<GuidePageQuery['displayPage']>;

type Props = {
  currentSort: SortOption;
  onSortChanged: (sort: string) => void;
  availableSorts: SortOption[];
  headerText?: string;
  error?: ErrorLike;
  description?: string;
  showPLPBreadcrumbs?: boolean;
  preserveBreadcrumbSpace?: boolean;
  hideActions?: boolean;
  displayPage?: DisplayPage | null;
  queryResult?: ProductListPageResultFragment | null;
  belowHeader?: ReactNode;
  belowLayout?: ReactNode;
  children?: React.ReactNode;
};

export const ProductListingMobile: React.FC<Props> = ({
  children,
  headerText,
  currentSort,
  queryResult,
  displayPage,
  onSortChanged,
  availableSorts,
  showPLPBreadcrumbs,
  preserveBreadcrumbSpace,
  hideActions,
  belowHeader,
  belowLayout
}) => (
  <div className="ProductListingMobile">
    {showPLPBreadcrumbs ? (
      <PLPBreadcrumbs />
    ) : preserveBreadcrumbSpace ? (
      <div className="ProductListingMobile__breadcrumbs-placeholder" aria-hidden>
        <PLPBreadcrumbs />
      </div>
    ) : null}

    <ProductListingMobileHeader
      headerText={headerText}
      totalItems={queryResult?.totalItems || 0}
      hideCount={hideActions}
      belowHeader={belowHeader}
    />

    <SalePercentageTags markdownPercentages={queryResult?.markdownPercentages || []} />

    {!hideActions && (
      <StickUnderNav className="ProductListingMobile__actions-wrapper">
        <ExceedConstrain className="ProductListingMobile__actions">
          <ProductListingMobileFilter queryResult={queryResult} displayPage={displayPage} />
          <ProductListingMobileSort
            availableSorts={availableSorts}
            currentSort={currentSort}
            onSortChanged={onSortChanged}
          />
        </ExceedConstrain>
      </StickUnderNav>
    )}
    {children}
    {belowLayout}
  </div>
);
